export const currencyUnitDetails = [
    { "name": "thousands", "value": 1000, "description": "10^3" },
    { "name": "ten thousands", "value": 10000, "description": "10^4" },
    { "name": "hundred thousands", "value": 100000, "description": "10^5" },
    { "name": "millions", "value": 1000000, "description": "10^6" },
    { "name": "billions", "value": 1000000000, "description": "10^9" },
    { "name": "lakhs", "value": 100000, "description": "10^5, commonly used in South Asia" },
    { "name": "crores", "value": 10000000, "description": "10^7, commonly used in South Asia" }
]